export const Region = {
  MALAYSIA: "MY",
  INDO: "ID",
};
